/**
 * StatsCards Component - Schedule statistics display
 */

import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Calendar, Clock, Users, FileCheck } from 'lucide-react';

export default function StatsCards({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
      <Card className="bg-slate-900 border-slate-800">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="p-1.5 sm:p-2 bg-blue-500/10 rounded-lg">
              <Calendar className="w-4 h-4 sm:w-5 sm:h-5 text-blue-500" />
            </div>
            <div className="min-w-0">
              <p className="text-slate-400 text-[10px] sm:text-sm">Total Shifts</p>
              <p className="text-lg sm:text-xl font-bold text-white" data-testid="total-shifts">
                {stats.totalShifts}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-900 border-slate-800">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="p-1.5 sm:p-2 bg-emerald-500/10 rounded-lg">
              <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500" />
            </div>
            <div className="min-w-0">
              <p className="text-slate-400 text-[10px] sm:text-sm">Total Hours</p>
              <p className="text-lg sm:text-xl font-bold text-white" data-testid="total-hours">
                {stats.totalHours}h
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-900 border-slate-800">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="p-1.5 sm:p-2 bg-purple-500/10 rounded-lg">
              <Users className="w-4 h-4 sm:w-5 sm:h-5 text-purple-500" />
            </div>
            <div className="min-w-0">
              <p className="text-slate-400 text-[10px] sm:text-sm">Staff</p>
              <p className="text-lg sm:text-xl font-bold text-white" data-testid="staff-count">
                {stats.employeeCount}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-900 border-slate-800">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="p-1.5 sm:p-2 bg-yellow-500/10 rounded-lg">
              <FileCheck className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-500" />
            </div>
            <div className="min-w-0">
              <p className="text-slate-400 text-[10px] sm:text-sm">Draft/Pub</p>
              <p className="text-lg sm:text-xl font-bold text-white" data-testid="status-count">
                <span className="text-yellow-400">{stats.draftCount}</span>
                {' / '}
                <span className="text-emerald-400">{stats.publishedCount}</span>
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
